module.exports = __webpack_public_path__ + "static-portal/img/nygl2.db57885.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nygl2.png
// module id = OpMu
// module chunks = 4